import ContactPage from "../../components/contactPage/ContactPage.jsx";

const CompanyContactPage = (props) => (
  <ContactPage
    createAspRequest={props.createAspRequest}
    onRequestError={props.onRequestError}
    fetchAspTopProvidersByMatchScore={props.fetchAspTopProvidersByMatchScore}
    handleBack={props.handleBack}
    handleNext={props.handleNext}
    isFillingMethodAutoJump={props.isFillingMethodAutoCompanyContactJump}
    match_score_weights={props.match_score_weights}
    onFillingMethodAutoBackToFillingMethod={
      props.onFillingMethodAutoCompanyContactBackToFillingMethod
    }
  />
);

export default CompanyContactPage;
